export enum SessionMeetingStatus {
	Waiting = 'waiting',
	Accepted = 'accepted',
	Complete = 'complete',
	Awaiting_Acceptance = "awaiting_acceptance",
	Cancelled ='cancelled',
	Pending_Payment = 'pending_payment',
	Cancelled_By_Mentor='cancelled_by_mentor',
	Cancelled_By_Student='cancelled_by_student',
	Refunded_Processing ='refund_processing',
	Refunded='refunded',
	Completed_Session = 'completed',
    Missed_Session = 'missed_session'
	

};
